export const DataLayerConstants = {
    customDataLayer: "customDataLayer",
    dataLayer: "dataLayer",
    paywallEventName: "paywallEvent",
    displayAttribute: "Display"
};
